import { compose } from 'ramda'
import { connect as reduxConnect } from 'react-redux'
import { DragSource } from 'react-dnd'

import { withTheme } from 'modules/util'
import { updatePartLocation } from '../../../actions'

import draggablePartTheme from './theme.scss'

const iconSource = {
  beginDrag(props) {
    props.onBeginDrag()
    return props
  },
  endDrag(props, monitor) {
    if (monitor.didDrop()) {
      const { containerSize, delta, itemId } = monitor.getDropResult()
      const diffX = delta.x / containerSize.width
      const diffY = delta.y / containerSize.height

      props.updatePartLocation(itemId, diffX, diffY)
    }
    props.onActivate()
  }
}

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}

export default compose(
  reduxConnect(null, { updatePartLocation }),
  withTheme(draggablePartTheme),
  DragSource('Evidence', iconSource, collect)
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/DraggablePart/enhancers.js